export default function handlebars() {
  let html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Loop through the data object, and replace the {{variables}} that match the data keys with the data values
  Object.entries(data).forEach(_ref => {
    let [key, value] = _ref;
    html = html.replace(new RegExp(`{{${key}}}`, 'g'), value || '');
  });
  return html;
}